/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, December 23rd 2021, 10:16:45 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useTranslatedText } from "core";
import { OpenMarketPlaceButtonWrapper, InstallFromFileDialog } from "prebuilt-services";
import { ProcessDefinitionList, ProcessDefinitionInfoButtonWrapper } from "service-builder";
import { PageTitle, OSActionButton } from "ui-widgets";

export const ServicesListPage = () => {
  const LANG = useTranslatedText();

  return (
    <div className="os-main-serviceslist-container">
      <PageTitle title={LANG.services}>
        <div className="table-top-actions">
          <ProcessDefinitionInfoButtonWrapper>
            <OSActionButton actionStyle="add">Create New Service From Scratch</OSActionButton>
          </ProcessDefinitionInfoButtonWrapper>
          <OpenMarketPlaceButtonWrapper>
            <OSActionButton actionStyle="add">Use Prebuilt Service Template</OSActionButton>
          </OpenMarketPlaceButtonWrapper>
          <InstallFromFileDialog
            renderOpenButton={({ handleOpen }) => (
              <OSActionButton onClick={handleOpen} actionStyle="add">
                Install Service From File
              </OSActionButton>
            )}
          />
        </div>
      </PageTitle>
      <ProcessDefinitionList />
    </div>
  );
};
